module.exports = __webpack_public_path__ + "img/fiesta-americana.18d1d0fd.svg";